// extracted by mini-css-extract-plugin
module.exports = {"global-setting":"style_global-setting__BqTRh"};